import type { DataCollectionSubmissionStatus, ReportingPeriod } from "../api/dataCollectionTypes";
import type { EntityOptionFieldType } from "../api/dictionaryTypes";
import type { MetricAggregationType } from "../api/portfolioMonitoringTypes";
import type { WorkflowType } from "../api/workflowTypes";

export const reportingPeriodCaptionsMap: Record<ReportingPeriod, string> = {
  Month: "Month",
  Quarter: "Quarter",
  Year: "Year",
  LastTwelveMonths: "LTM",
};

export const dataSubmissionStatusCaptionsMap: Record<DataCollectionSubmissionStatus, string> = {
  Draft: "Draft",
  Pending: "Pending Submission",
  Scheduled: "Scheduled",
  Completed: "Completed",
};

export const metricAggregationTypeCaptionMap: Record<MetricAggregationType, string> = {
  EndOfPeriod: "End of Period",
  Sum: "Sum",
};

export const entityOptionFieldTypeCaptionMap: Record<EntityOptionFieldType, string> = {
  Country: "Countries",
  State: "States",
  Currency: "Currencies",
  TaxForm: "Tax Forms",
  InvestorCategory: "Investor Categories",
  FormPfName: "Form PF Names",
  Chapter3Status: "Chapter 3 Statuses",
  Chapter4FatcaStatus: "Chapter 4 Fatca Statuses",
  Irs1099Code: "IRS 1099 Codes",
  IndustryOrSector: "Industries / Sectors",
  Geography: "Geographies",
};

export const workflowTypeCaptionMap: Record<WorkflowType, string> = {
  InvestorDetailsChangeRequest: "Investor Details",
  InvestorBankAccountChangeRequest: "Bank Details",
  InvoiceProcessing: "Invoice Processing",
  InvestmentAcquisition: "Investment Acquisition",
  InvestorCapitalCall: "Investor Capital Call",
  FundCapitalCallDistribution: "Fund Capital Call/Distribution",
  PcapUpload: "PCAP Upload",
  InvestorCapitalCallChecklist: "Investor Capital Call / Distribution Checklist",
  InvestorDistributionChecklist: "Investor Distribution Checklist",
  InvestorTransferChecklist: "Investor Transfer Checklist",
  NavPreparationChecklist: "NAV Preparation Checklist",
  MembersChangeRequest: "Contact Access",
};
